
function parallax() {
	$('.collections-primary .title').css('top', ($('.section-title').height() - $('body').scrollTop() / 6));
}

$(window).on('scroll', parallax); 

$(document).ready(function(){
	var collectionNumber, marginTop;

	function addMargin(collectionNumber, marginTop) {
		$('.collections-primary.collection-' + collectionNumber + ' .title').css('margin-top', marginTop + '%');
	}
	//addMargin(3, 200);
	//addMargin(5, 350);
    addMargin(3, 13);
    addMargin(5, 23);
    addMargin(7, 35);
    addMargin(9, 46);
});



// JS media queries 
// in this case, being used for parallax bg positioning
function getWidth() {
    var windowWidth = $( window ).width();

  
  
    if ( windowWidth > 1220 ) {
        
      	console.log("Greater than or equal to 1221");
      
      
    } else if ( windowWidth <= 1220 && windowWidth > 980 ) {
        
      	console.log("Between 1220 and 981 (inclusive)");

        $('#collection-parallax-3').parallax({
            positionX: '-700'
        });
      
      	$('#collection-parallax-5').parallax({
            positionX: '-700'
        });
      
      
      
    } else if ( windowWidth <= 980 && windowWidth > 740 ) {
        
      	console.log("Between 980 and 741 (inclusive)");
		
      	$('#collection-parallax-3').parallax({
            positionX: '-1000'
        });
      	$('#collection-parallax-5').parallax({
            positionX: '-800'
        });
    }  
}

$( window ).load(function() {
    getWidth();
});

$( window ).resize(function() {
    getWidth();
});
